import { Link } from 'react-router-dom';
const BusTabs = (props) => {
    return (
        <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
            <li className="nav-item" role="presentation">
                <Link to={"/bus/search"} className={props.pageName === "SEARCH" ? "nav-link active bg-primary text-white" : "nav-link"}>SEARCH</Link>
            </li>
            <li className="nav-item" role="presentation">
                <Link to={"/bus/bookinglist"} className={props.pageName === "BOOKINGLIST" ? "nav-link active bg-primary text-white" : "nav-link"}>BOOKINGS</Link>
            </li>
        </ul>
    );
};

export default BusTabs;
